import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b8682e5c")

_pushScopeId("data-v-b8682e5c")
const _hoisted_1 = {
  key: 0,
  class: "display-flex align-items-center"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "no-margin" }, "Will Call", -1)
const _hoisted_3 = {
  key: 2,
  class: "display-flex align-items-center"
}
const _hoisted_4 = { class: "no-margin" }
const _hoisted_5 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_7 = {
  key: 1,
  class: "display-flex align-items-center"
}
const _hoisted_8 = { class: "no-margin" }
const _hoisted_9 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "We may call to confirm order details.", -1)
const _hoisted_12 = {
  class: "item-after",
  style:  {
                      whiteSpace: 'normal',
                      fontSize: '14px',
                      textAlign: 'right',
                      maxWidth: '180px',
                    }
              
}
const _hoisted_13 = { class: "item-after display-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_f7_list_item_row = _resolveComponent("f7-list-item-row")
  const _component_f7_list_group = _resolveComponent("f7-list-group")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_accordion_content = _resolveComponent("f7-accordion-content")
  const _component_f7_block_title = _resolveComponent("f7-block-title")
  const _component_bill_of_materials = _resolveComponent("bill-of-materials")
  const _component_f7_block = _resolveComponent("f7-block")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_card = _resolveComponent("f7-card")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, { name: "checkout" }, {
    default: _withId(() => [
      _createVNode(_component_f7_navbar, { title: "Checkout" }, {
        left: _withId(() => [
          _createVNode(_component_f7_link, {
            "icon-only": "",
            "icon-f7": "chevron_left",
            href: "/store"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_f7_block, { class: "overview" }, {
        default: _withId(() => [
          _createVNode(_component_f7_list, {
            class: "no-margin-top flex-1",
            "accordion-list": ""
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.packages, (p, i) => {
                return (_openBlock(), _createBlock(_component_f7_list_item, {
                  key: 'package-' + i,
                  "accordion-item": "",
                  title: `${p.name} Shipping Details`
                }, {
                  after: _withId(() => [
                    (p.willCall)
                      ? (_openBlock(), _createBlock("div", _hoisted_1, [
                          _hoisted_2,
                          _createVNode(_component_f7_icon, {
                            style: {"padding":"0 10px"},
                            f7: "checkmark_circle",
                            color: "green"
                          })
                        ]))
                      : (!_ctx.validateAddress(p.address))
                        ? (_openBlock(), _createBlock(_component_f7_link, {
                            key: 1,
                            style: {"padding":"0 10px"},
                            tooltip: "You're missing some shipping info.",
                            color: "red",
                            "icon-f7": "exclamationmark_octagon"
                          }))
                        : (_openBlock(), _createBlock("div", _hoisted_3, [
                            _createVNode("p", _hoisted_4, " Ship on " + _toDisplayString(p.shipDate.toString().substring(0, 15)) + " to " + _toDisplayString(p.address.street), 1),
                            _createVNode(_component_f7_icon, {
                              style: {"padding":"0 10px"},
                              f7: "checkmark_circle",
                              color: "green"
                            })
                          ]))
                  ]),
                  default: _withId(() => [
                    _createVNode(_component_f7_accordion_content, null, {
                      default: _withId(() => [
                        _createVNode(_component_f7_list, null, {
                          default: _withId(() => [
                            _createVNode(_component_f7_list_item, {
                              checkbox: "",
                              checked: p.willCall,
                              "onUpdate:checked": ($event: any) => (p.willCall = $event),
                              title: "Will Call"
                            }, null, 8, ["checked", "onUpdate:checked"]),
                            _withDirectives(_createVNode(_component_f7_list_group, null, {
                              default: _withId(() => [
                                _createVNode(_component_f7_list_input, {
                                  label: "Ship date",
                                  type: "datepicker",
                                  placeholder: "Select date",
                                  outline: "",
                                  readonly: "",
                                  required: "",
                                  validate: "",
                                  value: p.shipDate,
                                  "onUpdate:value": ($event: any) => (p.shipDate = $event),
                                  "calendar-params": {
                    dateFormat: 'DD, MM dd, yyyy',
                    disabled: _ctx.notValidShipDate,
                    // 2 days from now
                    minDate: new Date(Date.now() + 86400000),
                    // 6 months from now
                    maxDate: new Date(Date.now() + 15770000000),
                  },
                                  "error-message": "A ship date is required"
                                }, null, 8, ["value", "onUpdate:value", "calendar-params"]),
                                _createVNode(_component_f7_list_input, {
                                  type: "text",
                                  value: p.address.name,
                                  "onUpdate:value": ($event: any) => (p.address.name = $event),
                                  label: "Name",
                                  name: "name",
                                  outline: "",
                                  required: "",
                                  validate: "",
                                  minlength: "2",
                                  "error-message": "Name must be at least 2 characters"
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_f7_list_input, {
                                  type: "text",
                                  value: p.address.street,
                                  "onUpdate:value": ($event: any) => (p.address.street = $event),
                                  label: "Shipping address",
                                  name: "address",
                                  outline: "",
                                  required: "",
                                  validate: "",
                                  minlength: "5",
                                  "error-message": "Please enter a valid street address"
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_f7_list_input, {
                                  outline: "",
                                  value: p.address.country,
                                  "onUpdate:value": ($event: any) => (p.address.country = $event),
                                  label: "Country",
                                  type: "select",
                                  required: "",
                                  validate: "",
                                  "error-message": "Please select a country"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryOptions, (c) => {
                                      return (_openBlock(), _createBlock("option", {
                                        key: c.code,
                                        value: c.code
                                      }, _toDisplayString(c.name), 9, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value"]),
                                _createVNode(_component_f7_list_item_row, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_f7_list_input, {
                                      type: "text",
                                      style: {"flex":"3"},
                                      value: p.address.city,
                                      "onUpdate:value": ($event: any) => (p.address.city = $event),
                                      label: "City",
                                      name: "city",
                                      outline: "",
                                      required: "",
                                      validate: "",
                                      minlength: "2",
                                      "error-message": "Please enter a city"
                                    }, null, 8, ["value", "onUpdate:value"]),
                                    (_ctx.getRegions(p.address.country).length > 0)
                                      ? (_openBlock(), _createBlock(_component_f7_list_input, {
                                          key: 0,
                                          outline: "",
                                          value: p.address.state,
                                          "onUpdate:value": ($event: any) => (p.address.state = $event),
                                          label: "State/Province",
                                          type: "select",
                                          required: "",
                                          validate: "",
                                          style: {"flex":"2"},
                                          "error-message": "Please select a state"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_6,
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRegions(p.address.country), (r) => {
                                              return (_openBlock(), _createBlock("option", {
                                                key: r.code,
                                                value: r.code
                                              }, _toDisplayString(r.name), 9, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value"]))
                                      : (_openBlock(), _createBlock(_component_f7_list_input, {
                                          key: 1,
                                          type: "text",
                                          style: {"flex":"2"},
                                          value: p.address.state,
                                          "onUpdate:value": ($event: any) => (p.address.state = $event),
                                          label: "State/Province",
                                          outline: "",
                                          required: "",
                                          validate: "",
                                          minlength: "2",
                                          "error-message": "Please enter a state/province"
                                        }, null, 8, ["value", "onUpdate:value"])),
                                    _createVNode(_component_f7_list_input, {
                                      type: "text",
                                      style: {"flex":"1"},
                                      value: p.address.zip,
                                      "onUpdate:value": ($event: any) => (p.address.zip = $event),
                                      label: _ctx.postalCodeLabel(p.address.country),
                                      name: "zip",
                                      outline: "",
                                      required: "",
                                      validate: "",
                                      pattern: _ctx.postalCodePattern(p.address.country),
                                      "error-message": _ctx.postalCodeError(p.address.country)
                                    }, null, 8, ["value", "onUpdate:value", "label", "pattern", "error-message"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1536), [
                              [_vShow, !p.willCall]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128)),
              _createVNode(_component_f7_list_item, {
                "accordion-item": "",
                title: "Billing Details"
              }, {
                after: _withId(() => [
                  (!_ctx.validateAddress(_ctx.billToAddress, true))
                    ? (_openBlock(), _createBlock(_component_f7_link, {
                        key: 0,
                        style: {"padding":"0 10px"},
                        tooltip: "You're missing some billing info.",
                        color: "red",
                        "icon-f7": "exclamationmark_octagon"
                      }))
                    : (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("p", _hoisted_8, " Bill to " + _toDisplayString(_ctx.billToAddress.name) + " at " + _toDisplayString(_ctx.billToAddress.street), 1),
                        _createVNode(_component_f7_icon, {
                          style: {"padding":"0 10px"},
                          f7: "checkmark_circle",
                          color: "green"
                        })
                      ]))
                ]),
                default: _withId(() => [
                  _createVNode(_component_f7_accordion_content, null, {
                    default: _withId(() => [
                      _createVNode(_component_f7_list, null, {
                        default: _withId(() => [
                          _createVNode(_component_f7_list_input, {
                            type: "text",
                            value: _ctx.billToAddress.name,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.billToAddress.name = $event)),
                            label: "Name",
                            name: "name",
                            outline: "",
                            required: "",
                            validate: "",
                            minlength: "2",
                            "error-message": "Name must be at least 2 characters"
                          }, null, 8, ["value"]),
                          _createVNode(_component_f7_list_input, {
                            type: "text",
                            value: _ctx.billToAddress.street,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.billToAddress.street = $event)),
                            label: "Billing address",
                            name: "address",
                            outline: "",
                            required: "",
                            validate: "",
                            minlength: "5",
                            "error-message": "Please enter a valid street address"
                          }, null, 8, ["value"]),
                          _createVNode(_component_f7_list_input, {
                            outline: "",
                            value: _ctx.billToAddress.country,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.billToAddress.country = $event)),
                            label: "Country",
                            type: "select",
                            required: "",
                            validate: "",
                            "error-message": "Please select a country"
                          }, {
                            default: _withId(() => [
                              _hoisted_9,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryOptions, (c) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: c.code,
                                  value: c.code
                                }, _toDisplayString(c.name), 9, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_f7_list_item_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_f7_list_input, {
                                type: "text",
                                style: {"flex":"3"},
                                value: _ctx.billToAddress.city,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.billToAddress.city = $event)),
                                label: "City",
                                name: "city",
                                outline: "",
                                required: "",
                                validate: "",
                                minlength: "2",
                                "error-message": "Please enter a city"
                              }, null, 8, ["value"]),
                              (_ctx.getRegions(_ctx.billToAddress.country).length > 0)
                                ? (_openBlock(), _createBlock(_component_f7_list_input, {
                                    key: 0,
                                    outline: "",
                                    value: _ctx.billToAddress.state,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.billToAddress.state = $event)),
                                    label: "State/Province",
                                    type: "select",
                                    required: "",
                                    validate: "",
                                    style: {"flex":"2"},
                                    "error-message": "Please select a state"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_10,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRegions(_ctx.billToAddress.country), (r) => {
                                        return (_openBlock(), _createBlock("option", {
                                          key: r.code,
                                          value: r.code
                                        }, _toDisplayString(r.name), 9, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["value"]))
                                : (_openBlock(), _createBlock(_component_f7_list_input, {
                                    key: 1,
                                    type: "text",
                                    style: {"flex":"2"},
                                    value: _ctx.billToAddress.state,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.billToAddress.state = $event)),
                                    label: "State/Province",
                                    outline: "",
                                    required: "",
                                    validate: "",
                                    minlength: "2",
                                    "error-message": "Please enter a state/province"
                                  }, null, 8, ["value"])),
                              _createVNode(_component_f7_list_input, {
                                type: "text",
                                style: {"flex":"1"},
                                value: _ctx.billToAddress.zip,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.billToAddress.zip = $event)),
                                label: _ctx.postalCodeLabel(_ctx.billToAddress.country),
                                name: "zip",
                                outline: "",
                                required: "",
                                validate: "",
                                pattern: _ctx.postalCodePattern(_ctx.billToAddress.country),
                                "error-message": _ctx.postalCodeError(_ctx.billToAddress.country)
                              }, null, 8, ["value", "label", "pattern", "error-message"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_f7_list_input, {
                            type: "tel",
                            value: _ctx.billToAddress.phone,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.billToAddress.phone = $event)),
                            label: "Phone Number",
                            name: "phone",
                            outline: "",
                            required: "",
                            validate: "",
                            pattern: "[0-9-() ]{10,}",
                            "error-message": "Please enter a valid phone number"
                          }, {
                            info: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.packages, (p, i) => {
            return (_openBlock(), _createBlock("div", {
              key: 'bom-' + i
            }, [
              _createVNode(_component_f7_block_title, null, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(p.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_bill_of_materials, {
                items: p.BOM,
                readonly: true,
                "show-price": _ctx.appState.admin || (_ctx.appState.builderData?.paysThroughPortal ?? false)
              }, null, 8, ["items", "show-price"])
            ]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_f7_card, { class: "total-card no-margin-top" }, {
        default: _withId(() => [
          _createVNode(_component_f7_list, { class: "no-margin-top" }, {
            default: _withId(() => [
              _createVNode(_component_f7_list_item, { title: "Shipping" }, {
                after: _withId(() => [
                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.shippingCostText), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_f7_list_item, { title: "Subtotal" }, {
                after: _withId(() => [
                  _createVNode("h3", _hoisted_13, _toDisplayString(_ctx.readablePrice), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_f7_button, {
            style: {"margin-top":"24px"},
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.purchase())),
            disabled: !_ctx.validatePurchase,
            fill: "",
            color: "green",
            text: "Submit purchase request",
            preloader: "",
            loading: _ctx.placingOrder
          }, null, 8, ["disabled", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})